import { render, staticRenderFns } from "./TizenModal.vue?vue&type=template&id=2225138a&lang=pug&"
import script from "./TizenModal.vue?vue&type=script&lang=js&"
export * from "./TizenModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports